/*
 * @Date         : 2021-08-02 18:06:09
 * @LastEditors: zhangxu
 * @LastEditTime: 2022-05-16 15:17:05
 * @FilePath: /daodao-biz-front/src/assets/dataModel/menu.ts
 */

class Menu {
  // 前端菜单枚举值
  MenuIdEnum = {
    dashboard: 1100,
    evaluationCenter: 1200,
    evaluationQuickLaunch: 1210,
    evaluationDiagnoseLibrary: 1220,
    evaluationDiagnoseInitiationRecord: 1230,
    evaluationDiagnoseReportRecord: 1240,
    growthCenter: 1400,
    openSeas: 1405,
    archives: 1410,
    diagnoseCenter: 1700,
    diagnoseLibrary: 1710,
    diagnoseInitiationRecord: 1720,
    diagnoseReportRecord: 1730,
    genReceiveCode: 1740,
    growUpDataCenter: 1900,
    growUpData: 1910,
    programmeCenter: 2000,
    programmeLibrary: 2010,
    programmeCreate: 2020,
    further: 2300,
    // furtherEnroll: 2305,
    furtherCustomer: 2310,
    furtherService: 2320,
    furtherSelectsubject: 2325,
    furtherCards: 2330,
    tools: 2600,
    universityLibrary: 2610,
    universityRank: 2620,
    majorLibrary: 2630,
    occupationLibrary: 2640,
    rankLine: 2650,
    batchScore: 2660,
    preBatch: 2670,
    assessParent: 2900,
    assess: 2910,
    channelPromotionCenter: 3000,
    channelPromotion: 3010,
    customerManagement: 3030,
    setting: 10000,
    accountSetting: 10010,
    customSetting: 10020,
    bill: 10030,
  }
  // 菜单附属关系及排列顺序
  private menuGroup: Array<{ menuId: number; children?: number[] }> = [
    { menuId: this.MenuIdEnum.dashboard },
    {
      menuId: this.MenuIdEnum.evaluationCenter,
      children: [
        this.MenuIdEnum.evaluationQuickLaunch,
        this.MenuIdEnum.evaluationDiagnoseLibrary,
        this.MenuIdEnum.evaluationDiagnoseInitiationRecord,
        this.MenuIdEnum.evaluationDiagnoseReportRecord,
      ],
    },

    {
      menuId: this.MenuIdEnum.growthCenter,
      children: [this.MenuIdEnum.openSeas, this.MenuIdEnum.archives],
    },
    {
      menuId: this.MenuIdEnum.diagnoseCenter,
      children: [
        this.MenuIdEnum.diagnoseLibrary,
        this.MenuIdEnum.diagnoseInitiationRecord,
        this.MenuIdEnum.diagnoseReportRecord,
        this.MenuIdEnum.genReceiveCode,
      ],
    },
    {
      menuId: this.MenuIdEnum.growUpDataCenter,
      children: [this.MenuIdEnum.growUpData],
    },
    {
      menuId: this.MenuIdEnum.channelPromotionCenter,
      children: [this.MenuIdEnum.channelPromotion,this.MenuIdEnum.customerManagement],
    },
    {
      menuId: this.MenuIdEnum.programmeCenter,
      children: [this.MenuIdEnum.programmeLibrary, this.MenuIdEnum.programmeCreate],
    },
    {
      menuId: this.MenuIdEnum.further,
      children: [
        this.MenuIdEnum.furtherService,
        // this.MenuIdEnum.furtherEnroll,
        this.MenuIdEnum.furtherCustomer,
        this.MenuIdEnum.furtherCards,
        this.MenuIdEnum.furtherSelectsubject,
      ],
    },
    {
      menuId: this.MenuIdEnum.tools,
      children: [
        this.MenuIdEnum.universityLibrary,
        this.MenuIdEnum.universityRank,
        this.MenuIdEnum.majorLibrary,
        // this.MenuIdEnum.occupationLibrary,
        this.MenuIdEnum.rankLine,
        this.MenuIdEnum.batchScore,
        this.MenuIdEnum.preBatch,
      ],
    },
    { menuId: this.MenuIdEnum.assessParent, children: [this.MenuIdEnum.assess] },
    {
      menuId: this.MenuIdEnum.setting,
      children: [this.MenuIdEnum.bill, this.MenuIdEnum.accountSetting, this.MenuIdEnum.customSetting],
    },
  ]

  // 后端返回代码的路由名字典
  public getSidebarRouteMap() {
    return {
      [this.MenuIdEnum.dashboard]: 'dashboard',
      [this.MenuIdEnum.evaluationCenter]: 'evaluation-center',
      [this.MenuIdEnum.evaluationQuickLaunch]: 'evaluation-quick-launch',
      [this.MenuIdEnum.evaluationDiagnoseLibrary]: 'evaluation-diagnose-library',
      [this.MenuIdEnum.evaluationDiagnoseInitiationRecord]: 'evaluation-diagnose-initiation-record',
      [this.MenuIdEnum.evaluationDiagnoseReportRecord]: 'evaluation-diagnose-report-record',
      [this.MenuIdEnum.growthCenter]: 'growth-center',
      [this.MenuIdEnum.openSeas]: 'open-seas',
      [this.MenuIdEnum.archives]: 'archives',
      [this.MenuIdEnum.growUpDataCenter]: 'growUpDataCenter',
      [this.MenuIdEnum.growUpData]: 'growUpData',
      [this.MenuIdEnum.channelPromotionCenter]: 'channelPromotionCenter',
      [this.MenuIdEnum.channelPromotion]: 'channelPromotion',
      [this.MenuIdEnum.customerManagement]: 'customerManagement',
      [this.MenuIdEnum.diagnoseCenter]: 'diagnose-center',
      [this.MenuIdEnum.diagnoseLibrary]: 'diagnose-library',
      [this.MenuIdEnum.diagnoseInitiationRecord]: 'diagnose-initiation-record',
      [this.MenuIdEnum.diagnoseReportRecord]: 'diagnose-report-record',
      [this.MenuIdEnum.genReceiveCode]: 'gen-receive-code',
      [this.MenuIdEnum.programmeCenter]: 'programme-center',
      [this.MenuIdEnum.programmeLibrary]: 'programme-library',
      [this.MenuIdEnum.programmeCreate]: 'programme-create',
      [this.MenuIdEnum.further]: 'further',
      // [this.MenuIdEnum.furtherEnroll]: 'further-enroll',
      [this.MenuIdEnum.furtherCustomer]: 'customers',
      [this.MenuIdEnum.furtherService]: 'service',
      [this.MenuIdEnum.furtherSelectsubject]: 'app-react/selectsubject',
      [this.MenuIdEnum.furtherCards]: 'cards',
      [this.MenuIdEnum.tools]: 'tools',
      [this.MenuIdEnum.universityLibrary]: 'university-library',
      [this.MenuIdEnum.universityRank]: 'university-rank',
      [this.MenuIdEnum.majorLibrary]: 'major-library',
      [this.MenuIdEnum.occupationLibrary]: 'occupation-library',
      [this.MenuIdEnum.batchScore]: 'batch-score',
      [this.MenuIdEnum.preBatch]: 'pre-batch',
      [this.MenuIdEnum.rankLine]: 'rank-line',
      [this.MenuIdEnum.assessParent]: 'assess-parent',
      [this.MenuIdEnum.assess]: 'assess',
      [this.MenuIdEnum.setting]: 'setting',
      [this.MenuIdEnum.accountSetting]: 'account-setting',
      [this.MenuIdEnum.customSetting]: 'custom-setting',
      [this.MenuIdEnum.bill]: 'bill',
    }
  }

  // 菜单代码的权限名字典
  public getPermissionMap() {
    return {
      [this.MenuIdEnum.dashboard]: '概况总览',
      [this.MenuIdEnum.evaluationCenter]: '评估中心',
      [this.MenuIdEnum.evaluationQuickLaunch]: '快速发起评估',
      [this.MenuIdEnum.evaluationDiagnoseLibrary]: '评估测评列表',
      [this.MenuIdEnum.evaluationDiagnoseInitiationRecord]: '评估活动追踪',
      [this.MenuIdEnum.evaluationDiagnoseReportRecord]: '评估报告记录',
      [this.MenuIdEnum.growthCenter]: '成长中心',
      [this.MenuIdEnum.openSeas]: '档案公海',
      [this.MenuIdEnum.archives]: '成长档案',
      [this.MenuIdEnum.diagnoseCenter]: '评估中心',
      [this.MenuIdEnum.diagnoseLibrary]: '评估工具库',
      [this.MenuIdEnum.diagnoseInitiationRecord]: '评估活动追踪',
      [this.MenuIdEnum.diagnoseReportRecord]: '评估报告记录',
      [this.MenuIdEnum.growUpDataCenter]: '成长方案库',
      [this.MenuIdEnum.growUpData]: '成长方案库',
      [this.MenuIdEnum.channelPromotionCenter]: '渠道推广',
      [this.MenuIdEnum.channelPromotion]: '业绩总览',
      [this.MenuIdEnum.customerManagement]: '客户管理',
      [this.MenuIdEnum.genReceiveCode]: '激活码管理',
      [this.MenuIdEnum.programmeCenter]: '方案中心',
      [this.MenuIdEnum.programmeLibrary]: '方案库',
      [this.MenuIdEnum.programmeCreate]: '创建方案',
      [this.MenuIdEnum.further]: '升学规划系统',
      // [this.MenuIdEnum.furtherEnroll]: '新增考生',
      [this.MenuIdEnum.furtherCustomer]: '升学获客',
      [this.MenuIdEnum.furtherService]: '1v1填报',
      [this.MenuIdEnum.furtherSelectsubject]: '新高考选科',
      [this.MenuIdEnum.furtherCards]: '发行志愿卡',
      [this.MenuIdEnum.tools]: '辅助工具',
      [this.MenuIdEnum.universityLibrary]: '院校查询',
      [this.MenuIdEnum.universityRank]: '院校排行榜',
      [this.MenuIdEnum.majorLibrary]: '专业查询',
      [this.MenuIdEnum.occupationLibrary]: '就业前景',
      [this.MenuIdEnum.rankLine]: '位次查询',
      [this.MenuIdEnum.batchScore]: '批次线',
      [this.MenuIdEnum.preBatch]: '提前批',
      [this.MenuIdEnum.assessParent]: '人才评估系统',
      [this.MenuIdEnum.assess]: '人才评估',
      [this.MenuIdEnum.setting]: '管理',
      [this.MenuIdEnum.bill]: '余额与账单',
      [this.MenuIdEnum.accountSetting]: '账号与权限',
      [this.MenuIdEnum.customSetting]: '自定义设置',
    }
  }

  // 左侧目录map
  public getSideBarGroup() {
    const sidebarRouteMap = this.getSidebarRouteMap()
    const permissionMap = this.getPermissionMap()
    return this.menuGroup.map((m1) => ({
      name: sidebarRouteMap[m1.menuId],
      path: `/${sidebarRouteMap[m1.menuId]}`,
      title: permissionMap[m1.menuId],
      menuId: m1.menuId,
      children: Array.isArray(m1.children)
        ? m1.children?.map((m2) => ({
            parent: sidebarRouteMap[m1.menuId],
            name: sidebarRouteMap[m2],
            path: `/${sidebarRouteMap[m2]}`,
            title: permissionMap[m2],
            menuId: m2,
          }))
        : undefined,
    }))
  }

  /**
   * 管理员通过一级权限获取二级权限
   */
  public getAdminPermissionList(perList) {
    type PreItem = { menuId: number; opt: number }
    const list: PreItem[] = []
    const pushList = (pers: number[]) => {
      pers.forEach((item) => {
        list.push({
          menuId: item,
          opt: 2,
        })
      })
    }
    perList.forEach((p) => {
      pushList(this.menuGroup.find((m) => m.menuId === p.menuId)?.children || [p.menuId])
    })
    return list
  }
}

export default new Menu()
